export enum DataCollectionStep {
  AimingShots = 'AimingShots',
  AnalysisShots = 'AnalysisShots',
  PitchComplete = 'PitchComplete',
}
